module.exports = __webpack_public_path__ + "static/media/arrowImg.c1855cc7.webp";